@if (!dataIsLoading()) {
  <div
    class="text-lg mt-12 md:text-xl font-bold mb-5 md:mt-14 text-mat-ef-revolution-primary-500"
    >
    @if (sharedService.showServicePackageSection() && !hasInsurance) {
      <T
      str="Service package"
      key="customerPortal.customer-portal.vehicle.servicepackage"
      tags="customer-portal, 3.1"
    ></T>
  }
  @if (sharedService.showServicePackageSection() && hasInsurance) {
    <T
    str="Service package and insurance"
    key="customerPortal.customer-portal.vehicle.service.package.and.insurance"
    tags="customer-portal, 3.1"
  ></T>
}
@if (!sharedService.showServicePackageSection() && hasInsurance) {
  <T
  str="Insurance"
  key="customerPortal.customer-portal.vehicle.insurance"
  tags="customer-portal, 3.10"
></T>
}
</div>
}
<mat-divider
  class="relative w-full text-mat-ef-revolution-supergrey-500"
></mat-divider>

@if (sharedService.showServicePackageSection()) {
  <customer-portal-app-skeleton-loader
    [loading]="!loadingServicePackage"
  ></customer-portal-app-skeleton-loader>
  <customer-portal-app-revolution-service-molecule
    [vehicle]="vehicle"
    [loading]="loadingServicePackage"
    >
  </customer-portal-app-revolution-service-molecule>
  <mat-divider
    class="relative w-full text-mat-ef-revolution-supergrey-500"
  ></mat-divider>
}

@if (hasInsurance) {
  <customer-portal-app-skeleton-loader
    [loading]="!loadingInsurance"
  ></customer-portal-app-skeleton-loader>
  <customer-portal-app-insurance-molecule>
  </customer-portal-app-insurance-molecule>
}
